// The left column of «Автоматизации» (um/2026-10-30/03 п.9): «Все сценарии», then the
// categories — the rail section of the trigger and its sections of records on branches. The body shows the cards of the chosen one.

import { useMeta, useSync } from '../sync/react.tsx';
import { navigate, useLocation } from '../shell/router.ts';
import { Branches, NavRow, useFolder } from '../shell/SideNav.tsx';
import { categories, triggerType, type Category } from './categories.ts';
import sh from '../shell/shell.module.css';

/** «Все сценарии» in the address of an open scenario: the list beside it stays the whole one. */
export const ALL = 'all';
export const catHref = (cat: string | null) => (cat ? `/a?cat=${encodeURIComponent(cat)}` : '/a');

/** The category the address points at: the chosen one (kept while a scenario is open beside the list), or that of a scenario opened by its link. */
export function useCategory(): string | null {
  const meta = useMeta();
  const { path, search } = useLocation();
  const id = path.split('/')[2];
  const cat = search.get('cat');
  if (cat === ALL) return null;
  if (cat || !id) return cat;
  const a = meta.automation(id); const t = a && triggerType(a);
  return t ? `t:${t}` : null;
}

export function AutomationsNav() {
  const meta = useMeta();
  const client = useSync();
  const cur = useCategory();
  const list = meta.automations();
  const count = (n: number) => <span className={sh.navCount}>{n}</span>;
  return (
    <>
      <NavRow icon="zap" label="Все сценарии" on={!cur} count={count(list.length)} onClick={() => navigate(catHref(null))} />
      {categories(list, client.menu, meta).map((c) => <CategoryFolder key={c.key} c={c} cur={cur} />)}
    </>
  );
}

function CategoryFolder({ c, cur }: { c: Category; cur: string | null }) {
  const [open, flip] = useFolder(`auto:${c.key}`);
  const count = (n: number) => <span className={sh.navCount}>{n}</span>;
  return (
    <div className={sh.navNode}>
      <NavRow icon={c.icon} label={c.label} on={cur === c.key || (!!cur && c.folded.includes(cur))} count={count(c.count)} onClick={() => navigate(catHref(c.key))}
        toggle={c.types.length ? { open, onToggle: flip, label: c.label } : undefined} />
      {open && c.types.length > 0 && (
        <Branches>
          {c.types.map((t) => <NavRow key={t.typeId} label={t.label} on={cur === `t:${t.typeId}`} count={count(t.count)} onClick={() => navigate(catHref(`t:${t.typeId}`))} />)}
        </Branches>
      )}
    </div>
  );
}

/** The head of the column: the open scenario's category or the chosen one. */
export function useAutomationsTitle(): string {
  const meta = useMeta();
  const client = useSync();
  const cur = useCategory();
  if (!cur) return 'Все сценарии';
  if (cur.startsWith('t:')) return meta.type(cur.slice(2))?.nameMany ?? 'Сценарии';
  return categories(meta.automations(), client.menu, meta).find((c) => c.key === cur)?.label ?? 'Сценарии';
}
